

export const TitleSchema = (intl) => ({
  title: "Schema",
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['showLeftDesignElem', 'showRightDesignElem'],
    },
  ],

  properties: {
    showLeftDesignElem: {
      title: 'Show Left Design',
      type: 'boolean',
    },
    showRightDesignElem: {
      title: 'Show Right Design',
      type: 'boolean',
    }
  },
  required: [],
});
